import { TimeOffProfileMenuService } from '@app/modules/time-off-v3/services/time-off-module-menu.service';
import { AccountMenuService } from './account-menu.service';
import { DocumentsMenuService } from './documents-menu.service';
import { DocumentsV2MenuService } from './documents-v2-menu.service';
import { PerformanceMenuService } from './performance-menu.service';

const MenuServices = [
    AccountMenuService,
    DocumentsMenuService,
    DocumentsV2MenuService,
    PerformanceMenuService,
    TimeOffProfileMenuService,
];

export { AccountMenuService, DocumentsMenuService, DocumentsV2MenuService, MenuServices, PerformanceMenuService };
